import React from 'react'
import { useParams } from 'react-router'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import PageCalling from 'src/components/common/PageCalling'
import Timer from 'src/components/views/join/Timer'
import useAPI from 'src/hooks/useAPI'
import { useCheckTelecomIsBlock } from 'src/hooks/useCheckTelecomIsBlock'
import { useTelList } from 'src/hooks/useTelList'
import useValid from 'src/hooks/useValid'
import { PartnerListData, RecoilStateList, TelTypeState, uiData } from 'src/recoil/common'
import {
  CertInput,
  CertSubmitBtn,
  PhoneVerificationWrap,
  Telecoms,
  TelInput,
  TelPhoneNumWrap,
  TelSelectorWrap,
} from 'src/styles/styledcomponent/views/join/PhoneVerification'
import { PartnerListType, PramsKeys } from 'src/types/type'
import { useAutoInputGuard } from "src/hooks/useAutoInputGuard";

const PhoneVerification = (props: any): JSX.Element => {
  const { onMoveToElement, RefInput, submit } = props
  const { pcode } = useParams<PramsKeys>()
  const telList = useTelList()
  const handleValid = useValid()
  const CertApi = useAPI('requestSendCertNumber')
  const JoinApi = useAPI('requestJoin')

  useCheckTelecomIsBlock()

  const { TelType, PhoneNum, CertNum, CertCheck, Timeout, termsAgree, authKeyValue, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const setTelType = useSetRecoilState(TelTypeState)
  const {
    layoutsConfirm: { submitBtn },
    // layoutsInsert: {
    //   // certs: { backgroundColor: certsBgColor, borderColor: certsBorderColor },
    //   // certs: {borderColor: certsBorderColor },
    //   // agency: { actColor },
    // },
  } = useRecoilValue(uiData)
  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)

  const { mutateAsync: getSendOtp, isLoading: certLoading } = CertApi.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    Pcode: pcode,
  })
  const { mutateAsync: JoinRequest, isLoading: joinLoading } = JoinApi.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    TranID: TransId,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData.TermsIdx,
    PCode: pcode,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })
  const handleJoinOnKeyUp = useAutoInputGuard(() => submit.join(JoinRequest))

  const CertOnKeyUpFunc = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      submit.validationCert(getSendOtp)
      setTimeout(() => {
        document.getElementById('certInput')?.focus()
      }, 1000)
    }
  }
  const TelecomSelector = async (option: number) => {
    setTelType(option)
    onMoveToElement()
  }

  return (
    // <PhoneVerificationWrap backgroundColor={certsBgColor} borderColor={certsBorderColor}>
    <PhoneVerificationWrap backgroundColor={'none'} borderColor={'none'} ref={props.RefElement}>
      <PageCalling active={certLoading || joinLoading} />
      <TelSelectorWrap>
        {telList?.map((element) => (
          <Telecoms
            key={element.idx}
            className={element.text}
            bgActive={TelType === element.idx}
            oneTelStyle={telList?.length === 1}
            actColor={PartnerData.FontColor}
            disabled={CertCheck}
            onClick={() => TelecomSelector(element.idx)}
          />
        ))}
      </TelSelectorWrap>
      <TelPhoneNumWrap>
        <TelInput
          className='ipt_phonenumber'
          borderColor={PartnerData.FontColor}
          backgroundColor={!CertCheck ? '#fff' : '#ccc'}
          type="tel"
          ref={RefInput}
          placeholder="휴대폰번호를 입력하세요."
          maxLength={11}
          value={PhoneNum}
          onChange={handleValid.phoneNumValid}
          onKeyUp={CertOnKeyUpFunc}
          disabled={CertCheck}
          onClick={onMoveToElement}
        />
        {!CertCheck ? (
          <CertSubmitBtn className='btn_send_sms'
            {...submitBtn}
            backgroundColor={PartnerData.FontColor}
            onClick={() => {
              submit.validationCert(getSendOtp)
              setTimeout(() => {
                document.getElementById('certInput')?.focus()
              }, 1000)
            }}
          >
            인증번호 발송
          </CertSubmitBtn>
        ) : (
          <section>
            <CertInput
              id={'certInput'}
              className='ipt_smscode'
              type="tel"
              placeholder="인증번호 입력"
              maxLength={4}
              value={CertNum}
              onChange={handleValid.certNumValid}
              onKeyUp={handleJoinOnKeyUp}
              autoComplete={'one-time-code'}
            />
            <Timer time={Timeout} />
          </section>
        )}
      </TelPhoneNumWrap>
    </PhoneVerificationWrap>
  )
}

export default PhoneVerification
